import { createRouter, createWebHashHistory } from 'vue-router';
// import { useStore } from 'vuex';

// const store = useStore();

import Home from '../views/index.vue';
import store from '../store';
import AddViolation from '../views/violations/settings/Violations/AddViolation.vue';
import AddViolationParameters from '../views/violations/settings/Violation Parameters/AddViolationParameters.vue';
import AddViolator from '../views/violations/settings/Violators/AddViolator.vue';
import DetailedReports from '../views/violations/ma_cargo_reports/DetailedReports.vue';
import EditViolation from '../views/violations/settings/Violations/EditViolation.vue';
import EditViolationParameter from '../views/violations/settings/Violation Parameters/EditViolationParameter.vue';
import EditViolator from '../views/violations/settings/Violators/EditViolator.vue';
import ViewViolation from '../views/violations/settings/Violations/ViewViolation.vue';
import ViewViolationParameters from '../views/violations/settings/Violation Parameters/ViewViolationParameters.vue';
import ViewViolators from '../views/violations/settings/Violators/ViewViolators.vue';
import AddViolationAction from '../views/violations/settings/ma_cargo_violation_actions/AddViolationAction.vue';
import ViolationList from '../views/violations/settings/ma_cargo_violation_actions/ViolationList.vue';
import NotFoundView from '@/views/violations/settings/NotFoundView.vue';
import SummaryReport from '@/views/violations/ma_cargo_reports/SummaryReport.vue';
import DriversViolationActions from '@/views/violations/ma_cargo_reports/DriversViolationActions.vue';
import DriverViolationDetails from '@/views/violations/settings/ma_cargo_violation_actions/DriverViolationDetails.vue';
import AddActionTaken from '@/views/violations/settings/Actions Taken/AddActionTaken.vue';
import ViewActionsTaken from '@/views/violations/settings/Actions Taken/ViewActionsTaken.vue';
import ABSDetailedReports from '@/views/violations/abs_reports/ABSDetailedReports.vue';
import ABSSummaryReport from '@/views/violations/abs_reports/ABSSummaryReport.vue';
import ABSIndividualViolationActions from '@/views/violations/abs_reports/ABSIndividualViolationActions.vue';
import ABSAddViolationAction from '@/views/violations/settings/abs_violation_actions/ABSAddViolationAction.vue';
import ABSViolationList from '@/views/violations/settings/abs_violation_actions/ABSViolationList.vue';
import WarningLetterDetail from '@/views/violations/settings/ma_cargo_violation_actions/WarningLetterDetail.vue';
import WarningLetterList from '@/views/violations/settings/ma_cargo_violation_actions/WarningLetterList.vue';
import HrViolationActions from '@/views/violations/settings/abs_violation_actions/HrViolationActions.vue';
import HrViolationActionDetail from '@/views/violations/settings/abs_violation_actions/HrViolationActionDetail.vue';
import ViewPermissions from '@/views/users/permissions/ViewPermissions.vue';
import UserManagement from '@/views/users/UserManagement.vue';
import Unauthorized from '@/views/Unauthorized.vue';
import Chat from '@/views/apps/chat.vue';
import Mailbox from '@/views/apps/mailbox.vue';
import Todo_list from '@/views/apps/todo_list.vue';
import Notes from '@/views/apps/notes.vue';
import ABSTrafficFinesReport from '@/views/violations/abs_reports/ABSTrafficFinesReport.vue';
import ABSVehicleTrafficFines from '@/views/violations/abs_reports/ABSVehicleTrafficFines.vue';

const routes = [
    //dashboard
    {
        path: '/home',
        name: 'Home',
        component: Home,
        meta: { requiresAuth: true }
    },

    // Violations
    {
        path: '/violation/add',
        name: 'add-violation',
        component: AddViolation,
        meta: {
            requiresAuth: true,
            requiredPermission: 'create_violation'
        }
    },

    {
        path: '/violation/view',
        name: 'viewViolation',
        component: ViewViolation,
        meta: {
            requiresAuth: true,
            requiredPermission: 'view_violation'
        }
    },

    {
        path: '/violation/edit/:id',
        name: 'editViolation',
        component: EditViolation,
        props: true,
        meta: {
            requiresAuth: true,
            requiredPermission: 'edit_violation'
        }
    },

    // Violation Parameters
    {
        path: '/violation/parameter/add',
        name: 'add-violationParameter',
        component: AddViolationParameters,
        meta: {
            requiresAuth: true,
            requiredPermission: 'create_violation_parameter'
        }
    },

    {
        path: '/violation/parameters/view',
        name: 'viewViolationParameters',
        component: ViewViolationParameters,
        meta: {
            requiresAuth: true,
            requiredPermission: 'view_violation_parameter'
        }
    },

    {
        path: '/violation/parameter/edit/:id',
        name: 'editViolationParameter',
        component: EditViolationParameter,
        props: true,
        meta: {
            requiresAuth: true,
            requiredPermission: 'edit_violation_parameter'
        }
    },

    // Violators
    {
        path: '/violator/add',
        name: 'add-violator',
        component: AddViolator,
        meta: {
            requiresAuth: true,
            requiredPermission: 'create_violator'
        }
    },
    {
        path: '/violator/view',
        name: 'viewViolator',
        component: ViewViolators,
        meta: {
            requiresAuth: true,
            requiredPermission: 'view_violator'
        }
    },

    {
        path: '/violator/edit/:id',
        name: 'editViolator',
        component: EditViolator,
        props: true,
        meta: {
            requiresAuth: true,
            requiredPermission: 'edit_violator'
        }
    },

    //Actions Taken
    {
        path: '/violation/actions_taken/add',
        name: 'actions-taken',
        component: AddActionTaken,
        meta: {
            requiresAuth: true,
            requiredPermission: 'create_taken_actions'
        }
    },
    {
        path: '/violation/actions_taken/view',
        name: 'viewActionsTaken',
        component: ViewActionsTaken,
        meta: {
            requiresAuth: true,
            requiredPermission: 'view_taken_actions'
        }
    },

    // MA CARGO Violation Reports
    {
        path: '/violation/reports/detailed',
        name: 'violation-detailed-reports',
        component: DetailedReports,
        meta: {
            requiresAuth: true,
            requiredPermission: 'view_violation_detailed_report'
        }
    },

    {
        path: '/violation/reports/summary',
        name: 'violation-summary-reports',
        component: SummaryReport,
        meta: {
            requiresAuth: true,
            requiredPermission: 'view_violation_summary_report'
        }
    },

    {
        path: '/violation/reports/drivers',
        name: 'drivers-violation-report',
        component: DriversViolationActions,
        meta: {
            requiresAuth: true,
            requiredPermission: 'view_driver_violation_actions'
        }
    },

    {
        path: '/violation/reports/drivers/:employeeId',
        name: 'drivers-violation-report-details',
        component: DriverViolationDetails,
        props: true,
        meta: {
            requiresAuth: true,
            requiredPermission: 'view_driver_violation_actions'
        }
    },

    // MA CARGO Violation Actions
    {
        path: '/violation/list',
        name: 'violation-list',
        component: ViolationList,
        meta: {
            requiresAuth: true,
            requiredPermission: 'view_violation_actions'
        }
    },

    {
        path: '/violation/action/add',
        name: 'addViolationAction',
        component: AddViolationAction,
        meta: {
            requiresAuth: true,
            requiredPermission: 'create_violation_actions'
        }
    },

    // Warning Letters Routes
    {
        path: '/violation/action/warning-letter-detail/:id',
        name: 'ma-cargo-Warning-Letter-Detail',
        component: WarningLetterDetail,
        props: true,
        meta: {
            requiresAuth: true,
            requiredPermission: 'view_warning_letters'
        }
    },

    {
        path: '/violation/action/warning-letters/list',
        name: 'ma-cargo-warning-letters-list',
        component: WarningLetterList,
        meta: {
            requiresAuth: true,
            requiredPermission: 'view_warning_letters'
        }
    },

    // ABS Violation Reports
    {
        path: '/abs/violation/reports/detailed',
        name: 'abs-violation-detailed-reports',
        component: ABSDetailedReports,
        meta: {
            requiresAuth: true,
            requiredPermission: 'view_abs_violation_detailed_report'
        }
    },

    {
        path: '/abs/violation/reports/summary',
        name: 'abs-violation-summary-reports',
        component: ABSSummaryReport,
        meta: {
            requiresAuth: true,
            requiredPermission: 'view_abs_violation_summary_report'
        }
    },

    {
        path: '/abs/violation/reports/bus',
        name: 'abs-bus-violation-report',
        component: ABSIndividualViolationActions,
        meta: {
            requiresAuth: true,
            requiredPermission: 'view_abs_bus_violation_report'
        }
    },

    {
        path: '/abs/traffic-fines/vehicle',
        name: 'abs-traffic-fines-vehicle',
        component: ABSVehicleTrafficFines,
        meta: {
            requiresAuth: true,
            requiredPermission: 'view_abs_traffic_fines'
        }
    },

    {
        path: '/abs/traffic-fines/reports',
        name: 'abs-traffic-fines-reports',
        component: ABSTrafficFinesReport,
        meta: {
            requiresAuth: true,
            requiredPermission: 'view_abs_traffic_fines'
        }
    },

    // ABS Violation Actions
    {
        path: '/abs/violation/list',
        name: 'abs-violation-list',
        component: ABSViolationList,
        meta: {
            requiresAuth: true,
            requiredPermission: 'view_violation_actions'
        }
    },

    {
        path: '/abs/violation/action/add',
        name: 'addAbsViolationAction',
        component: ABSAddViolationAction,
        meta: {
            requiresAuth: true,
            requiredPermission: 'create_violation_actions'
        }
    },

    // HR Actions Routes
    {
        path: '/abs/violation/action/hr-actions',
        name: 'abs-hr-actions',
        component: HrViolationActions,
        meta: {
            requiresAuth: true,
            requiredPermission: 'view_hr_actions'
        }
    },

    {
        path: '/abs/violation/action/hr-actions/:id',
        name: 'abs-hr-actions-details',
        component: HrViolationActionDetail,
        props: true,
        meta: {
            requiresAuth: true,
            requiredPermission: 'view_hr_actions'
        }
    },

    // User Management
    {
        path: '/user/management',
        name: 'user-management',
        component: UserManagement,
        meta: {
            requiresAuth: true,
            requiredPermission: 'view_users'
        }
    },

    // Permissions Routes
    {
        path: '/user/permissions/list',
        name: 'view-permissions',
        component: ViewPermissions,
        meta: {
            requiresAuth: true,
            requiredPermission: 'manage_permissions'
        }
    },

    // Not Found Route
    {
        path: '/:catchAll(.*)',
        name: 'not-found',
        component: NotFoundView,
    },

    {
        path: '/unauthorized',
        name: 'unauthorized',
        component: Unauthorized,
        // meta: { layout: 'app' }
    },

    //components

    //fonts

    //pages

    //auth
    {
        path: '/',
        name: 'login',
        component: () => import(/* webpackChunkName: "auth-login" */ '../views/auth/login.vue'),
        meta: { layout: 'auth' },
    },
    {
        path: '/auth/register',
        name: 'register',
        component: () => import(/* webpackChunkName: "auth-register" */ '../views/auth/register.vue'),
        meta: { layout: 'auth' },
    },
    {
        path: '/auth/pass-recovery',
        name: 'pass-recovery',
        component: () => import(/* webpackChunkName: "auth-pass-recovery" */ '../views/auth/pass_recovery.vue'),
        meta: { layout: 'auth' },
    },

    //elements

    //tables

    //users
    {
        path: '/users/profile',
        name: 'profile',
        component: () => import(/* webpackChunkName: "users-profile" */ '../views/users/profile.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/users/account-setting',
        name: 'account-setting',
        component: () => import(/* webpackChunkName: "users-account-setting" */ '../views/users/account_setting.vue'),
        meta: { requiresAuth: true }
    },

    //drag&drop

    //charts

    //widgets

    //forms

    //apps
    {
        path: '/apps/chat',
        name: 'chat',
        component: Chat,
        meta: { requiresAuth: true }
    },

    {
        path: '/apps/mailbox',
        name: 'mailbox',
        component: Mailbox,
        meta: { requiresAuth: true }
    },

    {
        path: '/apps/todo-list',
        name: 'todo-list',
        component: Todo_list,
        meta: { requiresAuth: true }
    },

    {
        path: '/apps/notes',
        name: 'notes',
        component: Notes,
        meta: { requiresAuth: true }
    },

    //tables
];

const router = createRouter({
    history: createWebHashHistory(),
    linkExactActiveClass: 'active',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { left: 0, top: 0 };
        }
    },
});

// router.beforeEach(async (to, from, next) => {
//     // Set layout first
//     const layout = to.matched.some(record => record.meta.layout === 'auth') ? 'auth' : 'app';
//     store.commit('setLayout', layout);

//     // Check authentication state
//     await store.dispatch('checkAuthentication');
//     const isAuthenticated = store.getters.isAuthenticated;

//     console.log('Navigation guard - isAuthenticated:', isAuthenticated, 'to:', to.path);

//     // Redirect logic
//     if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
//         next({
//             name: 'login',
//             query: { redirect: to.fullPath }
//         });
//     } else if (to.matched.some(record => record.meta.layout === 'auth') && isAuthenticated) {
//         // If authenticated and trying to access auth page, redirect to home
//         next({ path: '/home' });
//     } else {
//         next();
//     }
// });

router.beforeEach(async (to, from, next) => {
    // Set layout first
    const layout = to.matched.some(record => record.meta.layout === 'auth') ? 'auth' : 'app';
    store.commit('setLayout', layout);

    // Check authentication state
    await store.dispatch('checkAuthentication');
    const isAuthenticated = store.getters.isAuthenticated;

    // Redirect logic
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!isAuthenticated) {
            // Not authenticated - redirect to login
            return next({
                name: 'login',
                query: { redirect: to.fullPath }
            });
        }

        // Check for required permissions
        if (to.meta.requiredPermission) {
            const hasPermission = store.getters.hasPermission(to.meta.requiredPermission);

            if (!hasPermission) {
                // User doesn't have permission - redirect to home or unauthorized page
                console.warn(`Unauthorized access attempt to ${to.path} - missing permission: ${to.meta.requiredPermission}`);

                return next({ name: 'unauthorized' });
            }
        }

        // Check company-specific access if needed
    //     const currentCompany = store.state.currentCompany;
    //     if (to.path.startsWith('/abs/') && currentCompany?.name !== 'ABS') {
    //         console.warn('User trying to access ABS routes without being in ABS company');
    //         return next({ name: 'Home' });
    //     }

    //     if (to.path.startsWith('/violation/') && currentCompany?.name !== 'MA Cargo') {
    //         console.warn('User trying to access MA Cargo routes without being in MA Cargo company');
    //         return next({ name: 'Home' });
    //     }
    } else if (to.matched.some(record => record.meta.layout === 'auth') && isAuthenticated) {
        // If authenticated and trying to access auth page, redirect to home
        return next({ path: '/home' });
    }

    // All checks passed
    next();
});

export default router;
